import React, {useState, useEffect} from 'react';
import AdminMenu from "../../../components/Admin/MenuDetalhes/AdminMenu";

import { Container, ContainerInputSearch, Title, Input,Content,CreateButton,CardItem,ContainerPaginate } from './styles';
import {producaov2 as api} from '../../../services/apis';
import { datePattern } from '../../../utils/Utils';
import copy from 'copy-to-clipboard';
import { Pagination, Loader } from "semantic-ui-react";




const VoittoJobs = () => {
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [data,setData] = useState([]);
  const [page,setPage] = useState(1);
  const [totalPages,setTotalPages] = useState(1);

  useEffect(() => {
    api.get("/admin/jobs",{
      params: {
        search,
        page: page
      }
    },{
      headers:{
        access_token: `voitto-token ${localStorage.getItem("oauth_token")}`
      }
    })
    .then(res => {
      setTotalPages(res.data.quant);
      setData(res.data.data);
      console.log(res);
    })
    .catch(err => console.error(err))

  },[])

  const copyToClipBoard = (value) => {
    copy(value);

    swal("Copiado com sucesso",`Antes de enviar ao cliente, entre no link e verifique se a vaga ainda permanece ativa`,"success");
  };


  function reloadJobs(p = page) {
    api.get("/admin/jobs",{
      params: {
        search,
        page: p
      }
    },{
      headers:{
        access_token: `voitto-token ${localStorage.getItem("oauth_token")}`
      }
    })
    .then(res => {
      setData(res.data.data);
      console.log(res);
    })
    .catch(err => console.error(err))
  }



  return (
    <>
     <AdminMenu />

    <Container>
    {loading ? (
          <Loader active inline="centered" size="massive" />
        ) : (
          <Content>
            <Title>Listar Jobs</Title>
            <ContainerInputSearch>
              <Input
                type="text"
                placeholder="Pesquise pelo requisito"
                onChange={(e) => setSearch(e.target.value)}
              />
                <CreateButton onClick={() => reloadJobs()} onKeyUp={(e) => e.key === "Enter" && reloadJobs()}>Buscar</CreateButton>
            </ContainerInputSearch>
            {
              data.map(elem => {
                return (
                  <CardItem>
                    <div>
                        <h2><strong>{elem.title}</strong></h2>
                        <p>Data criação: <strong>{datePattern(elem.data_created)}</strong></p>
                        <button onClick={() => copyToClipBoard(elem.url_redirect)}>Copy Link</button>
                    </div>
                    <section>
                      <p>{elem.description}</p>
                    </section>
                    <footer>
                      <p>Empresa: <strong>{elem.company}</strong></p>
                      <p>Saláro: <strong>{elem.salary == 0 ? "Não informado" : elem.salary}</strong></p>
                      <p>Localidade: <strong>{elem.location.join()}</strong></p>
                    </footer>
                  </CardItem>
                )
              })
            }
          </Content>

        )}
         <ContainerPaginate>
            <Pagination
              defaultActivePage={1}
              ellipsisItem={null}
              // siblingRange={1}
              totalPages={totalPages}
              onPageChange={(e, f) => {
                setPage(f.activePage);
                reloadJobs(f.activePage)
                window?.scrollTo({
                  top: 0,
                  behavior: "smooth"
                });
              }}
              page={page}
            />
          </ContainerPaginate>
    </Container>
    </>
  )
}

export default VoittoJobs;